import React from 'react'
import { LinearProgress } from '@mui/material'
import { KcTable } from '../common/kc-table'
import { CustomNoRowsOverlay } from '../common/kc-table/components'
import { formatDateTime } from '../../pages/HL7historyLogs/utils'
import AccessRestrictedMessage from './AccessRestricted'

const columns = [
  { field: 'orderNumber', headerName: 'Order Number', flex: .75 },
  { field: 'code', headerName: 'Connection Code', flex: 1 },
  { field: 'duration', headerName: 'Duration', flex: .5 },
  {
    field: 'connectionStatus',
    headerName: 'Connection Code Status',
    flex: 1,
  },
  { field: 'createdAt', headerName: 'Created At', flex: 1 , renderCell: (params) => params?.value ? formatDateTime(params.value) : 'N/A' },
  { field: 'startDate', headerName: 'Redeemed On', flex: 1, renderCell: (params) => params?.value ? formatDateTime(params.value) : 'N/A' },
  { field: 'endDate', headerName: 'Expires On', flex: 1 , renderCell: (params) => params?.value ? formatDateTime(params.value) : 'N/A' },
  { field: 'timeToExpire', headerName: 'Expires In', flex: 1 },
]


function ConnectionCodeHistoryTable(props) {
  const { rows, loading, totalCount, noDataMessage, hasHl7LogAccess = false } = props
    const [pageNo, setPage] = React.useState(0)
    const [pageSize, setPageSize] = React.useState(10)
  
  const initialState = {
    sorting: {
      sortModel: [{ field: 'startDate', sort: 'desc' }, { field: 'createdAt', sort: 'desc' }],
    },
  }

  return (
    
      <KcTable
        rows={rows || []}
        autoHeight
        maxHeight="100%"
        columns={columns}
        getRowId={(row) => row.id}
        rowCount={totalCount || 0}
        loading={loading}
        sortingOrder={['desc', 'asc']}
        initialState={initialState}
        removePadding
        pagination
        paginationMode="server"
        pageSize={pageSize}
        pageNo={pageNo}
        onPageChange={(newPage) => setPage(newPage)}
        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
        removeToolbar
        components={{
          LoadingOverlay: LinearProgress,
          NoResultsOverlay: () => (
            <CustomNoRowsOverlay text="No Connection Codes found" />
          ),
          NoRowsOverlay: () => (
            <CustomNoRowsOverlay text={!hasHl7LogAccess ? <AccessRestrictedMessage /> : noDataMessage || "No Connection Codes found"} />
          ),
        }}
      />
  )
}

export default ConnectionCodeHistoryTable
